import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import FiltroReportes from "../Components/FiltroReportes";
import FiltroReportesEstado2 from "../Components/FiltroReportesEstado2";

export const ReporteRecuperacionResponsable = () => { 
    const history = useHistory();
    const { state } = useLocation();
    const [clientes, setClientes] = useState([]);
    const [boxstate, setBoxState] = useBox();
    const [totalSaldo, setTotalSaldo] = useState(0);
    const [totalRecuperado, setTotalRecuperado] = useState(0);
    const [titulo, setTitulo] = useState("REPORTE DE RECUPERACION DE CARTERA")

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // console.log(state)

    useEffect(() => {
        // setLoader({ ...loader, mostrar: true });
        onExecute(state.ejercicio, state.periodo, state.tipo_grafica, state.tipo_cartera, state.estado_cartera, state.responsable_cobranza);
        // setLoader({ ...loader, mostrar: false });
    }, []);

    const getEstadoNombre = (estadoCartera) => {
        const estados = {
            P: "POR VENCER",
            V: "VENCIDA",
        };

        return estados[estadoCartera] || "";
    };

    const onExecute = (ejercicio, periodo, tipo_grafica, tipo_cartera, estado_cartera, responsable) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        // console.log(adr, sucursales)
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardReportes/ReporteGraficaRecuperacion?ejercicio=${ejercicio}&periodo=${periodo}&tipo_grafica=${state.tipo_grafica}&tipo_cartera=${state.tipo_cartera}&estado_cartera=${estado_cartera}&responsable_cobranza=${state.responsable_cobranza}&adr=${adr}&sucursales=${sucursales}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setClientes(result);
                    calcularTotalSaldo(result);
                    calcularTotalRecuperado(result);
                    setTitulo(`REPORTE DE RECUPERACION DE CARTERA ` + (getEstadoNombre(boxstate.estado_cartera) || getEstadoNombre(state.estado_cartera)) + ' DE ' + state.nombre)
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const calcularTotalSaldo = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.objetivo) || 0), 0);
        setTotalSaldo(total);
    };

    const calcularTotalRecuperado = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.recuperado) || 0), 0);
        setTotalRecuperado(total);
    };

    return (
        <PlantillaScreen
            titulo={titulo} 
            className_main={1}
            className={"reporte-recuperacion-responsable"}
        >
            <LoaderScreen loader={loader} />
            <div className="reporte-recuperacion-responsable-actions">
                <div
                    className="reporte-recuperacion-responsable-actions-regresar"
                    onClick={() => history.push('/Creditoycobranza/DashboardCobranza')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="reporte-recuperacion-responsable-actions-filtro">
                    <FiltroReportesEstado2
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        estadoinicial={state.estado_cartera}
                    />
                </div>
            </div>
            <div className="reporte-recuperacion-responsable-container scroll-4">
                <div className="reporte-recuperacion-responsable-header">
                    <div className="reporte-recuperacion-responsable-header-title">
                        <FormatListNumberedIcon /> Listado de Clientes
                    </div>
                    <div className="contador-convenios-encontrados">
                        Clientes Encontrados: {clientes.length}
                    </div>
                </div>
                <div className="reporte-recuperacion-responsable-container-table scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Sucursal</th>
                                <th>
                                    <div>Cliente</div>
                                </th>

                                <th>
                                    <div>Vencimiento</div>
                                </th>
                                <th>
                                    <div>Días Vencido</div>
                                </th>
                                <th>
                                    <div>Recuperado</div>
                                </th>
                                <th>
                                    <div>Objetivo</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((clt) => (
                                <tr>
                                    <td>{clt.sucursal}</td>
                                    <td>{clt.razon_social}</td>
                                    <td className="ta-center">{new Date(clt.vencimiento).toLocaleDateString()}</td>
                                    <td className="ta-center">{clt.dias_Vencido < 0 ? 0 : clt.dias_Vencido}</td>
                                    <td className="ta-right">{FormatMoney(clt.recuperado, 2)}</td>
                                    <td className="ta-right">{FormatMoney(clt.objetivo, 2)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="ta-right" colSpan={3}></td>
                                <td className="ta-right">Total:</td>
                                <td className="ta-right">
                                    {FormatMoney(totalRecuperado, 2)}
                                </td>
                                <td className="ta-right">
                                    {FormatMoney(totalSaldo, 2)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </PlantillaScreen>
    );
};